import { render, staticRenderFns } from "./createGeneralMeeting.vue?vue&type=template&id=640f91b7&scoped=true&"
import script from "./createGeneralMeeting.vue?vue&type=script&lang=js&"
export * from "./createGeneralMeeting.vue?vue&type=script&lang=js&"
import style0 from "./createGeneralMeeting.vue?vue&type=style&index=0&id=640f91b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f91b7",
  null
  
)

export default component.exports